<template>
  <v-dialog v-model="show" :max-width="maxWidth" @input="closeDialog" scrollable>
    <v-card elevation="0">
      <v-card-title>Referências</v-card-title>
      <v-card-subtitle
        >Veja abaixo outras referências ou documentos informativos sobre os índices calculados.</v-card-subtitle
      >
      <v-card-text>
        <v-tabs v-model="tab" grow>
          <v-tab v-for="tab in tabs" :key="tab.title" v-text="tab.title" />
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="tab in tabs" :key="tab.title + 'content'">
            <v-card>
              <v-card-title v-if="!!tab.description" v-text="tab.description" />
              <v-card-text>
                <v-row v-if="!!tab.topics || !!tab.table">
                  <v-col v-if="!!tab.topics">
                    <ul>
                      <li v-for="topic in tab.topics" :key="topic" v-html="topic" />
                    </ul>
                  </v-col>
                  <v-col v-if="!!tab.table">
                    <v-simple-table dense>
                      <tbody>
                        <thead>
                          <b>Pontuação</b>
                        </thead>
                        <tr v-for="(row, i) in tab.table.rows" :key="i + 'row'">
                          <td v-for="cell in row" :key="cell" v-text="cell" />
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="d-flex">
                    <img class="mx-auto" v-if="!!tab.imgSrc" :src="tab.imgSrc" style="max-height: 500px" /> </v-col
                ></v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { PUBLIC_STORAGE_URL } from '@/constants/global'

export default {
  name: 'DiseaseActivityInfoDialog',
  props: {
    maxWidth: {
      type: [String, Number],
      default: '60vw',
    },
  },
  data() {
    return {
      show: false,
      tab: null,
      tabs: [
        {
          title: 'BASDAI',
          description: 'BASDAI: Bath Ankylosing Spondylitis Disease Activity tab',
          topics: [
            'Índice de atividade de Bath para a espondilite anquilosante',
            'Escore de zero a 10. Se >=4 indica atividade da doença',
            'Uma mudança maior ou igual a 2 pontos após intervenção terapêutica é considerada significativa',
            'Fonte (português – PT): <a href="http://www.asas-group.org" target="_blank">Clique aqui</a>',
            'Fonte (inglês): <a href="http://basdai.com" target="_blank">Clique aqui</a>',
          ],
        },
        {
          title: 'ASDAS',
          description: 'ASDAS: Ankylosing Spondylitis Disease Activity Score',
          topics: [
            'Uma mudança >= 1,1 é clinicamente significante',
            'Uma mudança >= 2,0 é uma mudança muito significativa',
            'Uma mudança maior ou igual a 2 pontos após intervenção terapêutica é considerada significativa',
            'Fonte: <a href="http://www.asas-group.org" target="_blank">Clique aqui</a>',
          ],
          table: {
            rows: [
              ['<1,3', 'Remissão'],
              ['<2,1', 'Atividade Baixa'],
              ['2,2 a 3,5', 'Atividade Moderada'],
              ['>3,5', 'Atividade Alta'],
            ],
          },
        },
        {
          title: 'DAS-28',
          description: 'DAS-28: Disease Activity Score',
          topics: [
            'Uma redução de 0,6 na DAS-28 representa uma melhora moderada',
            'Uma redução maior que 1,2 representa uma melhora significativa',
            'Calculadora: <a href="http://www.das-score.nl" target="_blank">Clique aqui</a>',
            'Fonte: <a href="http://www.rheumatology.org" target="_blank">Clique aqui</a>',
          ],
          table: {
            rows: [
              ['<2,6', 'Remissão'],
              ['2,6 a 3,2', 'Atividade Baixa'],
              ['>3,2 a 5,1', 'Atividade Moderada'],
              ['>5,1', 'Atividade Alta'],
            ],
          },
        },
        {
          title: 'DAPSA',
          description: 'DAPSA: Disease Activity in PSoriatic Arthritis',
          topics: [
            'Articulações doloridas: o valor varia de 0 até 68 e representa a quantidade de articulações marcadas como doloridas',
            'Articulações inchadas: o valor varia de 0 até 66, pois na articulação do quadril não pode selecionar em inchada',
            'PCR: valor em mg/dl',
            'Fórmula DAPSA: AD + AI + PCR + activity + pain',
            `Fonte: <a href="${PUBLIC_STORAGE_URL}/disease-score-infographics/DAPSA_ENG.pdf" target="_blank">Clique aqui para baixar o relatório</a>`,
          ],
          table: {
            rows: [
              ['0 até 4', 'Remissão'],
              ['5 até 14', 'Atividade Baixa'],
              ['15 até 28', 'Atividade Moderada'],
              ['>28', 'Atividade Alta'],
            ],
          },
        },
        {
          title: 'HAQ',
          description: 'HAQ: Health Assessment Questionnaire',
          topics: [
            'A fórmula do HAQ é calculada a partir dos maiores escores de cada componente: somatório dos maiores escores de cada componente (o maior escore do componente 1 mais o maior escore do componente 2 mais o maior escore do componente 3 mais o maior escore do componente 4 mais o maior escore do componente 5 mais o maior escore do componente 6 mais o maior escore do componente 7 mais o maior escore do componente 8) dividido por 8',
            'Quanto maior a pontuação, maior é o grau de comprometimento funcional do paciente',
            `Fonte: <a href="${PUBLIC_STORAGE_URL}/disease-score-infographics/Relatrio_Artrite_Reumatoide_CP_21_2020.pdf" target="_blank">Clique aqui para baixar o relatório</a>`,
          ],
        },
        {
          title: 'MDA',
          imgSrc: PUBLIC_STORAGE_URL + '/disease-score-infographics/MDA.png',
        },
        {
          title: 'CASPAR',
          imgSrc: PUBLIC_STORAGE_URL + '/disease-score-infographics/CASPAR.jpeg',
        },
        {
          title: 'PASI',
          imgSrc: PUBLIC_STORAGE_URL + '/disease-score-infographics/PASI.png',
        },
      ],
    }
  },
  methods: {
    openDialog() {
      this.show = true
    },
    closeDialog() {
      this.show = false
    },
  },
}
</script>

<style scoped></style>
